
(function ($) {

    // Show hide popover
    $(".js-contact-us-popup-toggle").click(function () {
        
        $(".js-contact-us-popup-toggle").toggleClass("active", $(".js-contact-us-popup-container").is(":hidden"));
        $(".js-contact-us-popup-container").slideToggle("fast");
        const isOpen = $(".js-contact-us-popup-toggle").hasClass('active');
        $(".js-contact-us-popup-toggle-label").text(isOpen ? 'Lukk' : 'Chat');
    });

    $(document).on("click", function (event) {
        var $trigger = $(".js-contact-us-popup");
        if ($trigger !== event.target && !$trigger.has(event.target).length) {
            $(".js-contact-us-popup-toggle").removeClass("active");
            $(".js-contact-us-popup-container").slideUp("fast");
            $(".js-contact-us-popup-toggle-label").text("Chat");
        }
    });

})(jQuery);